import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import "./Visit_Status_History_Modal.css";
import { Table } from "react-bootstrap";
import { getData } from "../../../../utils/api";

const Visit_Status_History_Modal = ({
  show,
  onHide,
  setErr,
  id,
  HistoryData,
}) => {
  const formatMonth = (value) => {
    if (!value) return "";
    const [year, month] = value.split("-");
    const date = new Date(year, month - 1);
    return date.toLocaleString("en-US", { month: "short", year: "numeric" });
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const [data, setData] = useState([]);

  const getAllData = async () => {
    {
      const res = await getData(
        `/complaint-management/preventive-maintainance/visit-history/${id}`
      );
      setData(res?.data);
    }
  };

  useEffect(() => {
    getAllData();
  }, [id]);
  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Status History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Date</th>
                  <th>Remark</th>
                </tr>
              </thead>

              <tbody>
                {HistoryData?.length > 0 ? (
                  HistoryData?.map((d, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      {d?.createdAt
                        ? new Date(d.createdAt).toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })
                        : "Not Visit"}

                      <td>{d?.remark}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "center", padding: "10px" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="btn_holder"></div>
      </Modal.Body>
    </Modal>
  );
};

export default Visit_Status_History_Modal;
